import {NgModule} from '@angular/core';
import {AppCurrencyPipe} from '@shared/currency/currency.pipe';

@NgModule({declarations: [AppCurrencyPipe], exports: [AppCurrencyPipe]})
export class CurrencyModule {
}
